exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_Divider_21g3EQ753_cTX4zsPjVq3E {\n  display: flex;\n  width: 100%;\n  margin-bottom: 20px;\n\n}\n\n.IA_dropZones_1qLNoANEjDkBKcB9M95GzA {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}", ""]);

// Exports
exports.locals = {
	"IA_Divider": "IA_Divider_21g3EQ753_cTX4zsPjVq3E",
	"IA_dropZones": "IA_dropZones_1qLNoANEjDkBKcB9M95GzA"
};